import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import inmobiliariaDto from "../models/inmobiliariaDto";
import { InmobiliariaWriteDto } from "../components/inmobiliariaForm";
import { getCurrentUsername } from "../../../../services/userRolesService";

const softDeleteInmobiliaria = async (inmobiliariaId: number ) => {

    const axiosResponse: Promise<AxiosResponse> = axiosInstance.patch(`siscred-api-maestros/v1/inmobiliarias/desactivar/${inmobiliariaId}`, {
        nombreUsuario: getCurrentUsername()
    });
    
    return axiosResponse;

}

const createInmobiliaria = async (data: InmobiliariaWriteDto) => {

    const axiosResponse: AxiosResponse = await axiosInstance.post(`siscred-api-maestros/v1/inmobiliarias/crear`, data);
  
    return axiosResponse;
}

const updateInmobiliaria = async (data: InmobiliariaWriteDto) => {

    const axiosResponse: AxiosResponse = await axiosInstance.put(`siscred-api-maestros/v1/inmobiliarias/actualizar/${data.id}`, data);
  
    return axiosResponse;
}

export {
    softDeleteInmobiliaria,
    createInmobiliaria,
    updateInmobiliaria
}
